import { render, staticRenderFns } from "./IconShoppingCartSolid.vue?vue&type=template&id=46f0852a"
import script from "./IconShoppingCartSolid.vue?vue&type=script&lang=js"
export * from "./IconShoppingCartSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports